import * as Yup from "yup"
import { formTranslation } from "../../../locales/form"
import { passwordMinSize, passwordRegex } from "../../../utility/common/password"
import { nameof } from "../../../utility/common/nameof"
import { PasswordValues } from "../../PasswordInput/PasswordInput"

const nameMinSize = 2

export const getValidationSchema = () => {
    return Yup.object().shape({
        firstName: Yup.string()
            .requiredExcludeEmpty(formTranslation.firstNameRequired)
            .min(nameMinSize, formTranslation.firstNameInvalid),
        lastName: Yup.string()
            .requiredExcludeEmpty(formTranslation.lastNameRequired)
            .min(nameMinSize, formTranslation.lastNameInvalid),
        password: Yup.object({
            currentPassword: Yup.string().requiredExcludeEmpty(formTranslation.currentPasswordRequired),
            newPassword: Yup.string()
                .requiredExcludeEmpty(formTranslation.newPasswordRequired)
                .min(passwordMinSize, formTranslation.passwordInvalid)
                .matches(passwordRegex, {
                    message: formTranslation.passwordInvalid,
                    excludeEmptyString: true
                }),
            repeatPassword: Yup.string()
                .requiredExcludeEmpty(formTranslation.repeatPasswordRequired)
                .oneOf([Yup.ref(nameof<PasswordValues>("newPassword")), ""], formTranslation.repeatPasswordRequired)
        })
            .default(undefined)
            .nullable()
    })
}
